import styled from "@emotion/styled";

export const StreetName = styled.td`
  font-size: 14px;
  font-weight: 400;
  padding: 0 0.5rem;
  white-space: nowrap;
`;
